import API from "serviceshift-ui/api-client";

import { withCloseoutOverride } from "@/composables/useCloseoutOverride";

export default {
  clearAppointment({ commit }) {
    commit("replace", {
      state: "appointment",
      data: null
    });
  },
  createAppointment(_, { link, payload }) {
    return API.makeRequest(link, {
      method: "POST",
      data: payload
    });
  },
  fetchAppointment({ commit }, id) {
    return API.makeRequest(`/v2/appointments/${id}`).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  cancelAppointment({ commit }, { id, reason }) {
    return API.makeRequest(`/v2/appointments/${id}/cancel`, {
      method: "PUT",
      data: {
        reason
      }
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointment({ commit }, { link, data }) {
    const { href, method } = link;
    return API.makeRequest(href, {
      method,
      data
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointmentStatus({ commit }, { link, params }) {
    const { href, method } = link;
    return API.makeRequest(href, {
      method,
      data: params
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  // A tech-time edit here can complete the appointment, which the server gates on
  // close-out. withCloseoutOverride surfaces that 409 as the shared override modal
  // and retries with the reason, so TechnicianTimeEditModal needs no change of its
  // own. ignoreError lets the 409 body reach the override handler.
  updateAppointmentTimes({ commit }, { id, ...data }) {
    return withCloseoutOverride((overrideReason) =>
      API.makeRequest(`/v2/appointments/${id}/actual_times`, {
        method: "PUT",
        headers: { ignoreError: true },
        data: overrideReason
          ? { ...data, custom_form_override_reason: overrideReason }
          : data
      })
    ).then((res) => {
      commit("replace", {
        state: "job",
        data: res.data
      });
    });
  },
  // ignoreError: the close-out gate's 409 has no `message`, so the interceptor's
  // generic flash and RUM report would both be wrong here. The caller inspects the
  // rejection itself for every transition through this action, so nothing may be
  // swallowed silently.
  async updateAppointmentStatusAndTimes(_, { link, params }) {
    const { href, method } = link;
    const res = await API.makeRequest(href, {
      method,
      data: params,
      headers: { ignoreError: true }
    });
    return res.data;
  }
};
